<template>
  <main class="main-wrap">
    <div class="min-s-hight" style="width:100%">
      <section class="r-s-wrap">
        <div class="container devExtremeGridContainer">
          <div class="row ">
            <div class="col-12 col-sm-12 col-md-3 col-lg-4">
              <div class="form-group has-search " style="width:100%;">
                <span class="fa fa-search form-control-feedback"></span>
                <input
                  v-model="vendorReportSearched"
                  type="text"
                  class="form-control"
                  placeholder="Search by vendor name"
                  @keyup.enter="vendorAnalysis(0)"
                />
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-9 col-lg-8 ">
              <div class="pull-right displayflex mrtop">
                <!-- <input
                v-model="dateFrom"
                class="dateControl btnmaxwidth"
                type="date"
              />
              <input
                v-model="dateTo"
                class="mr-l20 dateControl btnmaxwidth"
                type="date"
                :min="dateFrom"
              /> -->

                <datepicker
                  v-if="onoffFirstDatePicker"
                  v-model="dateFrom"
                  :disabled-dates="disabledDatesFrom"
                  :monday-first="true"
                  :typeable="false"
                  class="my-datepicker mr-r20"
                  calendar-class="my-datepicker_calendar"
                  input-class="booking_input input-bl form-control "
                  format="MM/dd/yyyy"
                  placeholder="Select date"
                  :use-utc="true"
                  @selected="validationForSecondFilter"
                ></datepicker>

                <datepicker
                  v-if="onoff"
                  v-model="dateTo"
                  :disabled-dates="disabledDates"
                  :monday-first="true"
                  :typeable="false"
                  class="my-datepicker mr-r20"
                  calendar-class="my-datepicker_calendar"
                  input-class="booking_input input-bl form-control "
                  format="MM/dd/yyyy"
                  placeholder="Select date"
                  :use-utc="true"
                  @selected="validationForFirstFilter"
                ></datepicker>
                <!-- <button>Search</button> -->
                <button
                  type="button"
                  class="btn s-red-btn s-red-width  bigSearch"
                  @click="vendorAnalysis(0)"
                >
                  Search
                </button>
                <button
                  type="button"
                  class="btn s-red-btn s-red-width  smallSearch"
                  @click="vendorAnalysis(0)"
                >
                  <span class="fa fa-search form-control-feedback "></span>
                </button>
              </div>
            </div>
          </div>
          <div class="mr-t20 row col-chooser">
            <div style="max-width:100%;">
              <DxDataGrid
                ref="vendorAnalysisSection"
                :data-source="AllVendorArray"
                :show-borders="true"
                :hover-state-enabled="true"
                :remote-operations="false"
                :allow-column-reordering="true"
                :row-alternation-enabled="false"
                :column-hiding-enabled="false"
                :column-auto-width="true"
                key-expr="ProviderId"
                :show-column-lines="true"
                :show-row-lines="true"
              >
                <!-- <DxPaging :page-size="5" />
                      <DxPager
                        :show-page-size-selector="true"
                        :allowed-page-sizes="pageSizes"
                        :show-info="true"
                      /> -->

                <!-- <DxFilterRow :visible="true" /> -->
                <!-- <DxHeaderFilter :visible="true" /> -->
                <DxGroupPanel :visible="true" />
                <DxSearchPanel
                  :visible="false"
                  :highlight-case-sensitive="true"
                />
                <DxGrouping :auto-expand-all="true" />

                <DxPager
                  :allowed-page-sizes="[5, 10, 20]"
                  :show-page-size-selector="true"
                  :show-info="true"
                  :show-navigation-buttons="true"
                />
                <DxPaging :page-size="20" />
                <DxColumnChooser :enabled="true" />

                <DxColumn
                  data-field="ProviderName"
                  caption="Vendor Name"
                  cell-template="VTemplate"
                  :allow-sorting="true"
                />
                <div slot="VTemplate" slot-scope="{ data }">
                  <h6> {{ data.ProviderName }} </h6>
                </div>
                <DxColumn
                  data-field="ServiceFormCount"
                  caption="Service Form Count"
                  cell-template="ServiceCountTemplate"
                  :allow-sorting="true"
                  alignment="center"
                />
                <div slot="ServiceCountTemplate" slot-scope="{ data }">
                  <h6>
                    {{ data.ServiceFormCount }}
                  </h6>
                </div>
                <DxColumn
                  data-field="ServiceFormEnquiryCount"
                  caption="Inquiry Count"
                  cell-template="InquiryCountTemplate"
                  :allow-sorting="true"
                  alignment="center"
                />
                <div slot="InquiryCountTemplate" slot-scope="{ data }">
                  <h6>
                    {{ data.ServiceFormEnquiryCount }}
                  </h6>
                </div>
                <!-- commenting on 07-10-2022
                <DxColumn
                  data-field="StripeAccountId"
                  caption="Vendor stripe payout account ID"
                  cell-template="stripeAccountIDTemplate"
                  :allow-sorting="true"
                  alignment="left"
                  :width="200"
                />
                <div slot="stripeAccountIDTemplate" slot-scope="{ data }">
                  <h6>
                    {{ data.StripeAccountId }}
                  </h6>
                </div> -->
                <!-- <DxColumn
        data-field="BuildingCount"
        caption="Building Count"
        cell-template="BuildingCountTemplate"
        :allow-sorting="true"
        alignment="center"
        :width="220"
      />
      <div slot="BuildingCountTemplate" slot-scope="{ data }">
        <h6>
          {{ data.BuildingAllocation }}
        </h6>
      </div> -->
                <DxColumn
                  data-field="PopularBuilding"
                  caption="Popular Building"
                  cell-template="PopularBuildingTemplate"
                  :allow-sorting="true"
                  alignment="left"
                />
                <div slot="PopularBuildingTemplate" slot-scope="{ data }">
                  <h6>
                    {{
                      data.PopularBuilding === 'None'
                        ? '-'
                        : data.PopularBuilding
                    }}
                  </h6>
                </div>
              </DxDataGrid>
            </div>
          </div>
        </div></section
      >
      <loader v-if="isLoading"></loader>
    </div>
  </main>
</template>
<script>
import loader from '@views/loader'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import { superAdminMethods } from '@state/helpers'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  // DxStateStoring,
  // DxHeaderFilter,
  // DxFilterRow,
} from 'devextreme-vue/data-grid'
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxGrouping,
    DxGroupPanel,
    DxColumnChooser,
    loader,
    datepicker,
  },
  props: ['startDate', 'endDate'],
  data() {
    return {
      AllVendorArray: [],
      dateFrom: '2018-01-01',
      dateTo: '2021-02-15',
      vendorReportSearched: '',
      isLoading: false,
      disabledDates: {
        to: new Date(this.startDate),
      },
      disabledDatesFrom: {
        from: new Date(this.endDate),
      },
      onoff: true,
      onoffFirstDatePicker: true,
    }
  },
  watch: {
    vendorReportSearched: {
      handler: function(val, oldVal) {
        if (!val) {
          this.AllVendorArray = []
          this.vendorAnalysis(0)
        }
      },
      deep: true,
    },
  },

  created() {
    this.dateFrom = this.startDate
    this.dateTo = this.endDate

    this.vendorAnalysis(0)
    // this.categoryAnalysis()
  },
  methods: {
    ...superAdminMethods,

    // Toggling of the flag variable for the validation of date

    validationForSecondFilter(res) {
      this.disabledDates = {
        to: res,
      }
      this.onoff = false
      this.onoff = true
    },
    // Toggling of the flag variable for the validation of date

    validationForFirstFilter(res) {
      this.disabledDatesFrom = {
        from: res,
      }
      this.onoffFirstDatePicker = false
      this.onoffFirstDatePicker = true
    },
    // GET API to fetch the inquiry count on the basis of particular vendor

    async vendorAnalysis(recordCount) {
      try {
        this.isLoading = true
        let dateFromFilter = moment(String(this.dateFrom))
          .add(1, 'd')
          .format('YYYY-MM-DD')
        // this.dateTo = moment(String(this.dateTo)).format('YYYY-MM-DD')
        let dateTOFilter = moment(String(this.dateTo))
          .add(1, 'd')
          .format('YYYY-MM-DD')
        const vendorsReport = await this.VendorAnalysisAsyncReportingAPI({
          start: dateFromFilter,
          end: dateTOFilter,
          vendorName: this.vendorReportSearched
            ? this.vendorReportSearched
            : '',
          recordAvailable: recordCount,
        })
        if (recordCount) {
          this.AllVendorArray = this.AllVendorArray.concat(vendorsReport)
        } else {
          this.AllVendorArray = vendorsReport
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },

    // Adding the pagination in the dev extreme grid on  event trigger

    isLastPage(pagination) {
      var currentPage = pagination.value + 1
      var TotalPage = this.$refs['vendorAnalysisSection'].instance.pageCount()
      var pageIndex =
        this.$refs['vendorAnalysisSection'].instance.pageIndex() + 1
      if (
        pageIndex === currentPage &&
        currentPage === TotalPage &&
        this.AllVendorArray.length > 99
      ) {
        console.log('Pagination started working')
        this.vendorAnalysis(this.AllVendorArray.length)
      } else if (pagination.fullName === 'paging.pageSize') {
        if (
          typeof pagination.previousValue === 'number' &&
          typeof pagination.value === 'number' &&
          pagination.value > pagination.previousValue &&
          this.AllVendorArray.length > 99
        ) {
          console.log('Pagination due to page size increment')
          this.vendorAnalysis(this.AllVendorArray.length)
        }
      }
    },
  },
}
</script>

<style scoped></style>
